import { useABContext } from "@src/contexts/ab-testing/ab-context";
import React from "react";
import { DimensionBreakdown } from "./dimension-breakdown";
import { EventStep } from "./event-step";
import { ApplyValueStateType } from ".";
import { Form, Input, InputNumber, Select } from "antd";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { FormInstance } from "antd/lib/form";
import { FunnelFilter, FunnelFilterShow } from "./funnel-filter";
import { SignificanceLevel } from "../metric-performance/component/metric-performance-item/significance-level";
import { css } from "@emotion/react";

const ControlInputComponent: React.FC<{
  handleApply: (values: ApplyValueStateType) => void;
  applyValue: ApplyValueStateType;
  form: FormInstance<any>;
}> = ({ handleApply, applyValue, form }) => {
  const { chartForm } = useABContext();

  React.useEffect(() => {
    form.setFieldValue(
      ChartFormFieldsEnum.FUNNEL_SIGNIFICANT + "_validate_field",
      form.getFieldValue(ChartFormFieldsEnum.FUNNEL_SIGNIFICANT),
    );
  }, [form]);

  return (
    <div className="pt-0 flex flex-col">
      <div className="flex flex-wrap justify-start items-start">
        <div className="flex-1">
          <DimensionBreakdown form={chartForm} />
        </div>

        <div
          css={css`
            .ant-form-item {
              margin: 0 !important;
            }
          `}
        >
          <SignificanceLevel
            form={form}
            fieldName={ChartFormFieldsEnum.FUNNEL_SIGNIFICANT + "_validate_field"}
            _onChange={(value) => {
              form.setFieldValue(ChartFormFieldsEnum.FUNNEL_SIGNIFICANT, value);
            }}
          />
        </div>
      </div>
      <div className="flex flex-wrap items-center mt-2">
        <Form.Item className="m-0" name={ChartFormFieldsEnum.FUNNEL_FILTER}>
          <FunnelFilter />
        </Form.Item>
        <FunnelFilterShow form={form} />
      </div>
      <div className="flex items-start mt-4">
        <EventStep handleApply={handleApply} applyValue={applyValue} form={chartForm} />
      </div>
    </div>
  );
};

export const ControlInput = React.memo(ControlInputComponent);

export const ControlInputInstance: React.FC = () => {
  return (
    <div>
      <Form.Item name={ChartFormFieldsEnum.FUNNEL_SIGNIFICANT} hidden>
        <InputNumber />
      </Form.Item>
      <Form.Item name={ChartFormFieldsEnum.FUNNEL_BREAKDOWN} hidden>
        <Select />
      </Form.Item>
      <Form.Item name={ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE} hidden>
        <Select />
      </Form.Item>
      <Form.Item name={ChartFormFieldsEnum.FUNNEL_EVENT_LISTS} hidden>
        <Input />
      </Form.Item>
    </div>
  );
};
